angular.module("vgresiduos").controller("storageEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `geracoes/${$stateParams.id}`);
		};
	}
]);
